import { memberApiClient } from '../httpClient'

export const getMembers = async (
    year: number,
    skip: number,
    limit: number,
    activeOnly: boolean,
    subscriberId?: string,
) => {
    let endpoint = `/api/v1/member?year=${year}&skip=${skip}&limit=${limit}&activeOnly=${activeOnly}`
    if (subscriberId && subscriberId != '') {
        endpoint += `&subscriberId=${subscriberId}`
    }
    return await memberApiClient.get(endpoint)
}

export const getCoverageByPersonId = async (personId: string) =>
    await memberApiClient.get(`/api/v1/member/${personId}/coverages?productLine=Dental`)

export const getEligibilityTransactions = async (
    skip: number,
    limit: number,
    activeOnly: boolean,
    destinationInterchangeId: string,
) => {
    let endpoint = `/api/v1/member/eligibility/transactions?skip=${skip}&limit=${limit}&activeOnly=${activeOnly}&destinationInterchangeId=${destinationInterchangeId}`
    return await memberApiClient.get(endpoint)
}

export const getEligibilityTransaction = async (id: string) =>
    await memberApiClient.get(`/api/v1/member/eligibility/transaction/${id}`)
